// extracted by mini-css-extract-plugin
export var content = "Feedback-module__content___NNiOk";
export var resource = "Feedback-module__resource___VmyMw";
export var resources = "Feedback-module__resources___0kP6T";
export var rightSection = "Feedback-module__rightSection___050o-";
export var section = "Feedback-module__section___jLwwy";